import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import useNearbyIntl from '../../hooks/useNearbyIntl'

const NearbyTrainPositionsFooter = ({ updatedAt, themeName }) => {
  const { locale, formatMessage } = useNearbyIntl()

  // updatedAt はtrains.json中に、tid-converterでTime.current.to_iで生成しているが、Javascriptで扱うため、ミリ秒に変換するため、* 1000にする。
  const updatedAtStr = () => moment.tz(updatedAt * 1000, 'Asia/Tokyo').format("H:mm:ss")
    
  return (
    <footer className={`c-NearbyTrainPositionsFooter is_${locale}`}>
      <div className="c-NearbyTrainPositionsFooter-note">
        <p>
          {formatMessage('App.TrainPositions.footer.actualMayDiffer')}
        </p>
        {updatedAt > 0 && (
          <p>{formatMessage('App.TrainPositions.footer.displayTime')}{updatedAtStr()}</p>
        )}
      </div>
    </footer>
  )
}

NearbyTrainPositionsFooter.propTypes = {
  updatedAt: PropTypes.number,
  themeName: PropTypes.string.isRequired,
}

export default NearbyTrainPositionsFooter
